import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';

import MyAccountTitle from './titles/MyAccountTitle';
import AdminTitle from './titles/AdminTitle';
import DevPortalTitle from './titles/DevPortalTitle';
import HomeTitle from './titles/HomeTitle';
import InteractiveIcon from './InteractiveIcon';
import IoTHubTitle from './titles/IoTHubTitle';
import ArchitectTitle from './titles/ArchitectTitle';
import ReportingTitle from './titles/ReportingTitle';
import RulesTitle from './titles/RulesTitle';
import ServiceManagementTitle from './titles/ServiceManagementTitle';
import SubscriptionsTitle from './titles/SubscriptionsTitle';

import classes from './Header.module.css';

const Header = props => {
    const [anchorEl, setAnchorEl] = useState(null);

    const title = () => {
        switch (props.app) {
            case 'myaccount':
                return <MyAccountTitle />;
            case 'admin':
                return <AdminTitle />;
            case 'devportal':
                return <DevPortalTitle />;
            case 'home':
                return <HomeTitle />;
            case 'iothub':
                return <IoTHubTitle />;
            case 'architect':
                return <ArchitectTitle />;
            case 'reporting':
                return <ReportingTitle />;
            case 'rules':
                return <RulesTitle />;
            case 'servicemanagement':
                return <ServiceManagementTitle />;
            case 'subscriptions':
                return <SubscriptionsTitle />;
            default:
                break;
        }
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleHelp = () => {
        props.help();

        handleClose();
    };

    const handleSignOut = () => {
        props.signOut();

        handleClose();
    };

    const renderButton = () => {
        if (props.isBootStrapping) {
            return (
                <div className={classes.menuBoxEmpty}>
                    <CircularProgress
                        className={classes.circularProgress}
                    />
                </div>
            );
        }

        return (
            <InteractiveIcon
                className={classes.menuBox}
                icon="material-icons"
                iconClassName={classes.menuBoxIcon}
                label="Applications Menu"
                onClick={() => { props.toggle(true); }}
            >
                apps
            </InteractiveIcon>
        );
    };

    return (
        <header className={classes.Header}>
            {renderButton()}
            {title()}
            <div className={classes.contextBox}>
                <span>{props.userName}</span>
                <Button
                    onClick={handleClick}
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                >
                    <i className="fas fa-bars" aria-hidden="true" />
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    onClose={handleClose}
                    classes={{
                        paper: classes.contextMenu
                    }}
                    TransitionComponent={Fade}
                >
                    <MenuItem onClick={handleHelp}>
                        <img
                            className={classes.contextIcon}
                            src="/assets/images/helpIconColor.svg" alt="help icon"
                        />
                        Help
                    </MenuItem>
                    <MenuItem onClick={handleSignOut}>
                        <img
                            className={classes.contextIcon}
                            src="/assets/images/signoutIconColor.svg" alt="sign out icon"
                        />
                        Sign Out
                    </MenuItem>
                </Menu>
            </div>
        </header>
    );
};

export default Header;
